module.exports = __webpack_public_path__ + "img/kaifashang_icon0.3c545712.png";